"use strict";

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var cx = require("classnames");
var Info_1 = require("./Info");
var EndpointChooser = function EndpointChooser(_a) {
  var selectedEndpoint = _a.selectedEndpoint,
      onChangeEndpoint = _a.onChangeEndpoint;
  return React.createElement(
    "div",
    { className: "root", "data-jsx": 3949980999
    },
    React.createElement(_style2.default, {
      styleId: 3949980999,
      css: ".root[data-jsx=\"3949980999\"] {color: rgba(255, 255, 255, .25);}.endpoint[data-jsx=\"3949980999\"] {padding: 5px 12px 6px 12px}.endpoint[data-jsx=\"3949980999\"].active[data-jsx=\"3949980999\"] {padding: 7px 9px 8px 9px;margin: 0 -2px;z-index: 2;}.fw6,\n.root[data-jsx=\"3949980999\"] {font-weight: 600;}.flex,\n.root[data-jsx=\"3949980999\"],\n.chooser[data-jsx=\"3949980999\"] {display: -ms-flexbox;display: flex;}.itemsCenter,\n.root[data-jsx=\"3949980999\"],\n.chooser[data-jsx=\"3949980999\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center;}.ml16,\n.chooser[data-jsx=\"3949980999\"] {margin-left: 16px;}.flex,\n.root[data-jsx=\"3949980999\"],\n.chooser[data-jsx=\"3949980999\"] {display: -ms-flexbox;display: flex;}.itemsCenter,\n.root[data-jsx=\"3949980999\"],\n.chooser[data-jsx=\"3949980999\"] {-webkit-box-align: center;-ms-flex-align: center;-ms-grid-row-align: center;align-items: center;}.bgBlack50,\n.endpoint[data-jsx=\"3949980999\"] {background-color: rgba(0,0,0,.5);}.br2,\n.endpoint[data-jsx=\"3949980999\"] {border-radius: 2px;}.relative,\n.endpoint[data-jsx=\"3949980999\"] {position: relative;}.pointer:hover,\n.endpoint[data-jsx=\"3949980999\"]:hover {cursor: pointer;}.ttu,\n.endpoint[data-jsx=\"3949980999\"] {text-transform: uppercase;}.darkerBlue,\n.endpoint[data-jsx=\"3949980999\"].active[data-jsx=\"3949980999\"] {color: #0f202e;}.bgLightGray,\n.endpoint[data-jsx=\"3949980999\"].active[data-jsx=\"3949980999\"] {background-color: #c3bfc4;}.mt6,\na[data-jsx=\"3949980999\"] {margin-top: 6px;}.dib,\na[data-jsx=\"3949980999\"] {display: inline-block;}"
    }),
    React.createElement(
      "div",
      {
        "data-jsx": 3949980999
      },
      "API"
    ),
    React.createElement(
      "div",
      { className: "chooser", "data-jsx": 3949980999
      },
      React.createElement(
        "div",
        { className: cx('endpoint', {
            'active': selectedEndpoint === 'RELAY'
          }), onClick: function onClick() {
            return onChangeEndpoint('RELAY');
          }, "data-jsx": 3949980999
        },
        "Relay"
      ),
      React.createElement(
        "div",
        { className: cx('endpoint', {
            'active': selectedEndpoint === 'SIMPLE'
          }), onClick: function onClick() {
            return onChangeEndpoint('SIMPLE');
          }, "data-jsx": 3949980999
        },
        "Simple"
      )
    ),
    React.createElement(
      Info_1.default,
      null,
      selectedEndpoint === 'SIMPLE' ? React.createElement(
        "div",
        {
          "data-jsx": 3949980999
        },
        React.createElement(
          "div",
          {
            "data-jsx": 3949980999
          },
          "The Simple API is our most simplistic GraphQL API. It is highly recommended in use with Apollo, as it is much simpler than the Relay API."
        ),
        React.createElement(
          "a",
          { href: "https://www.graph.cool/docs/reference/simple-api/overview-heshoov3ai", target: "_blank", "data-jsx": 3949980999
          },
          "Simple API Docs"
        )
      ) : React.createElement(
        "div",
        {
          "data-jsx": 3949980999
        },
        React.createElement(
          "div",
          {
            "data-jsx": 3949980999
          },
          "In order to use Relay, the backend must implement a spec that Relay needs. The Relay API fully supports this spec, so you can implement fully-fledged Relay Apps with Graphcool."
        ),
        React.createElement(
          "a",
          { href: "https://www.graph.cool/docs/reference/relay-api/overview-aizoong9ah", target: "_blank", "data-jsx": 3949980999
          },
          "Relay API Docs"
        )
      )
    )
  );
};
exports.default = EndpointChooser;


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/GraphiQL/QueryHeader/EndpointChooser.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/GraphiQL/QueryHeader/EndpointChooser.js
// module chunks = 0